
		<info-modal [title]="title" (onOk)="ok()">
			<p>{{message}}</p>
		</info-modal>
	